import React from 'react';
import { FaGamepad } from 'react-icons/fa';
import { HOME_TEXTS } from './constants';
import '../../styles/Home.css';

/**
 * En-tête de la section des applications
 * Affiche le titre et la description
 *
 * @component
 * @returns {JSX.Element} L'en-tête de la section des applications
 */
const AppsSectionHeader = () => {
  return (
    <div className="section-header">
      <div className="section-title-wrapper">
        <div className="section-icon-container">
          <FaGamepad className="section-icon" />
        </div>
        <h2 className="section-title">{HOME_TEXTS.APPS_SECTION.TITLE}</h2>
      </div>
      <p className="section-subtitle">{HOME_TEXTS.APPS_SECTION.SUBTITLE}</p>
      <div className="section-divider">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default AppsSectionHeader;
